import React, {useEffect, useState} from 'react';
import moment from 'moment';
import {useAppDispatch, useAppSelector} from '../../../store/hooks';
import {SuperPOCTool} from '../../../models/IPOCToolWebPortal';
import {ApplicationState} from '../../../store';
import {useParams} from 'react-router-dom';
import {Box} from '@mui/material';
import {actionCreators} from '../../../store/POCToolsWebPortal/POCToolsWebPortalActions';
import Loader from '../generalPurpose/Loader';
import POCToolMiniTool from './POCToolSinglePageContent/POCToolMiniTool';
import PageContainer from './PageContainer';
import {trackPOCTool, trackPageView} from '../../../Util/firebaseAnalytics';

export default function MiniToolsSinglePage() {
  const {id} = useParams();

  const dispatch = useAppDispatch();

  let pointOfCareTool: SuperPOCTool = useAppSelector(
    (state: ApplicationState) => state.POCToolsWebPortal.superPointOfCareTool,
  );
  const [isloading, setIsloading] = useState(true);

  const date = moment(pointOfCareTool?.lastUpdated)
    .format('MM/DD/YYYY')
    .toString();

  const description =
    pointOfCareTool?.description ?? 'No description available.';
  if (pointOfCareTool.id === id && isloading) {
    setIsloading(false);
  }
  useEffect(() => {
    dispatch(actionCreators.getMiniPOCToolById(id));
    trackPageView('POC MiniTools Single Page Screen');
  }, []);

  useEffect(() => {
    if (pointOfCareTool.id === id) {
      document.title = `${pointOfCareTool.name} | ACEP`;

      if (pointOfCareTool.name) {
        trackPOCTool(id, pointOfCareTool.name);
      }
    }
  }, [pointOfCareTool]);

  return isloading ? (
    <Loader />
  ) : (
    <div>
      <PageContainer
        links={[
          {name: 'Point-of-Care Tools', url: '../'},
          {name: pointOfCareTool.name, url: ''},
        ]}
        isThereBackButton>
        <Box paddingBottom={4}>
          <h1 style={styles.textTitle}>{pointOfCareTool.name}</h1>
          <p style={styles.textLastUpdated}>Updated on {date}</p>
          <p style={styles.textDescription}>{description}</p>
        </Box>
        <Box>
          {[...pointOfCareTool.miniTools]
            .sort((a, b) => a.order - b.order)
            .map(minitool => (
              <POCToolMiniTool
                key={minitool.id}
                miniToolsId={minitool.id}
                poctoolsId={id}
                title={minitool.name}
              />
            ))}
        </Box>
      </PageContainer>
    </div>
  );
}

const styles = {
  container: {
    paddingTop: 21,
    marginBottom: '5%',
  },
  textTitle: {
    fontSize: 28,
    fontWeight: '600',
    marginBottom: 10,
  },
  textLastUpdated: {
    fontSize: 14,
    fontcolor: '#333333',
    fontWeight: '400',
    marginBottom: 26,
  },
  textDescription: {
    fontSize: 18,
    fontcolor: '#000000',
    fontWeight: '400',
  },
  subDescription: {
    fontSize: 17,
    marginTop: 42,
    fontWeight: '400',
    lineHeight: '140%',
  },
  collapseButtonContainer: {
    display: 'flex',
    justifyContent: 'end',
    paddingBottom: 20,
  },
  collapseButton: {
    borderRadius: 100,
    borderWidth: 2,
    borderColor: '#1976D2',
  },
};
